/* eslint-disable */

import Vue from 'vue';

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
	// You can set your default options here
};


Vue.use(Toast, options);

import App from './App.vue';
import router from './router';
import store from './store/index';

import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);

import Breadcrumbs from './components/bread_crumbs';

Vue.component('Breadcrumbs', Breadcrumbs);

import VueFeather from 'vue-feather';

Vue.use(VueFeather);

import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor);

import VueApexCharts from 'vue-apexcharts';

import PxCard from './components/Pxcard.vue';

Vue.component(PxCard.name, PxCard);

import i18n from "./shared/vue-i18n";

// Import Theme scss
import './assets/scss/app.scss';

import config from './config.json';

Vue.prototype.$config = config
Vue.prototype.$eventBus = new Vue();

Vue.use(require('vue-moment'));

Vue.component('apexchart', VueApexCharts);

// Vue.use(VueI18n);

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import moment from 'moment'

Vue.prototype.moment = moment

Vue.filter('formatDate', function (value, $format = 'MM/DD/YYYY HH:MM') {
	if (value) {
		return moment(String(value)).format($format)
	}
});

Vue.config.productionTip = false;

import VueTextareaAutosize from 'vue-textarea-autosize'

Vue.use(VueTextareaAutosize)

import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
	id: 'G-VCKL65QRFG',
	router,
	checkDuplicatedScript: true
})

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app');